import { Outlet, createRootRoute } from '@tanstack/react-router';
import { Toaster } from '@/components/ui/sonner';
import { QueryProvider } from '@client/providers/query-provider';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <QueryProvider>
      <div className="min-h-screen bg-background text-foreground">
        <Outlet />
      </div>
      <Toaster richColors position="top-right" />
    </QueryProvider>
  );
}
